<div #addAdditionalComponentsFromCatalogModal class="modal fade" data-backdrop="static" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered modal-md modal-add-additional-components show-products-modal">
    <div class="modal-content no-border border-radius-0">
      <div class="modal-header text-uppercase font-size-16">
        <div class="modal-title">
          <ng-container i18n="@@app.added_products">Added products</ng-container>
        </div>
        <button type="button" (click)="cancelAddingProducts()" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="display-flex modal-body mx-3 my-2 px-0 pt-0 flex-column overflow-y-auto max-h-80vh">
        <table class="table-condensed border-table position-relative">
          <thead class="bg-light">
            <tr>
              <th class="px-2 w-20-px position-sticky top-45" i18n="@@app.image">Image</th>
              <th class="px-2 cursor-pointer w-120-px text-left position-sticky top-45">
                <ng-container i18n="@@app.reference">Reference</ng-container>
              </th>
              <th class="text-left position-sticky top-45">
                <ng-container i18n="@@app.e_number">E-number</ng-container>
              </th>
              <th class="text-left position-sticky top-45">
                <ng-container i18n="@@app.description">Description</ng-container>
              </th>
              <th class="text-right position-sticky top-45">
                <ng-container class="pl-15" i18n="@@app.quantity">Quantity</ng-container>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (productInCart of productsInCart; track productInCart) {
              <tr class="border-bottom-table">
                <td class="image-cell text-center">
                  <app-ui-image
                    [src]="productInCart?.product?.reference | catalogProductImage:false | async"
                    [alt]="productInCart?.product?.reference"
                  [height]="40"></app-ui-image>
                </td>
                <td class="text-left">
                  <div class="d-flex align-items-center">
                    {{ productInCart?.product?.reference }}
                  </div>
                </td>
                <td class="text-left">
                  {{ productInCart?.product?.enumber }}
                </td>
                <td class="text-left">
                  {{ productInCart?.product?.pDescription }}
                </td>
                <td class="text-right">
                  {{ productInCart?.quantity }}
                </td>
              </tr>
            }
            @for (productInCart of productsWithAdjustedQuantity; track productInCart) {
              <tr class="border-bottom-table">
                <td class="image-cell text-center">
                  <app-ui-image
                    [src]="productInCart?.article?.ref | catalogProductImage:false | async"
                    [alt]="productInCart?.article?.ref"
                  [height]="40"></app-ui-image>
                </td>
                <td class="text-left">
                  <div class="d-flex align-items-center">
                    {{ productInCart?.article?.ref }}
                  </div>
                </td>
                <td class="text-left">
                  {{ productInCart?.article?.eNumber }}
                </td>
                <td class="text-left">
                  {{ productInCart?.article?.description }}
                </td>
                <td class="text-right">
                  {{ productInCart?.quantity }}
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="modal-footer pt-0 no-border">
        <button type="button" (click)="cancelAddingProducts()"
          class="btn btn-light btn-lg text-uppercase border-rounded font-weight-normal mx-2"
          i18n="@@app.cancel">Cancel
        </button>
        <button appDisableMultipleClick
          type="button"
          class="btn btn-primary bg-light-blue btn-lg text-uppercase border-rounded mx-2 font-weight-normal"
          (click)="confirmAddingProducts()">
          <ng-container i18n="@@app.confirm">Confirm</ng-container>
        </button>
      </div>
    </div>
  </div>
</div>
